import { useContext, useEffect } from 'react';
import TrackWrapper, { type TrackWrapperProps } from '@/common/TrackWrapper';
import Section, { SectionId, SectionName } from '~/constants/vdp/section';
import UiContext from '~/context/vdp/UiContext';

export type OwnProps = Omit<TrackWrapperProps, 'event'> & {
  additionalCAs?: Record<string, any>;
  'data-nav-section'?: never;
  id?: never;
  section: Section;
};

export default function SectionViewedLogger({
  additionalCAs = {},
  children,
  section,
  threshold = 0.25,
  ...props
}: OwnProps) {
  const { setSectionMounted } = useContext(UiContext);

  useEffect(() => {
    setSectionMounted(section);
  }, [section, setSectionMounted]);

  return (
    <TrackWrapper
      element="section"
      data-nav-section={SectionId[section]}
      id={SectionId[section]}
      delay={0}
      event={{
        eventName: SectionName[section],
        customAttributes: {
          action: 'viewed',
          ...additionalCAs
        }
      }}
      threshold={threshold}
      trackOnce
      {...props}
    >
      {children}
    </TrackWrapper>
  );
}
